import { render, staticRenderFns } from "./merchants.vue?vue&type=template&id=12edf508"
import script from "./merchants.vue?vue&type=script&lang=js"
export * from "./merchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports